import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/blog6.css';
import blogImage from '../Asets/Blog.jpg';
import blog1 from '../Asets/blog26.jpeg';
import Header from '../components/header';
import Footer from '../components/footer';

const Blog = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            A Promise for Life: Fostering Sibling Bonds This Raksha Bandhan
          </h2>
          <br />
          <div className="published-badge">Published on: 09 August 2025</div>
          <br />

          <img
            src={blog1}
            alt="Raksha Bandhan Celebration at Red School House"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              <strong>
                A Promise for Life: Fostering Sibling Bonds This Raksha Bandhan
              </strong>
            </p>
            <p>
              At Red School, Vadodara, festivals are not just celebrated —
              they’re lived, experienced, and learned through. This Raksha
              Bandhan (9th August 2025), our campus came alive with vibrant
              colors, smiling faces, and an atmosphere brimming with love and
              learning.
            </p>
            <p>
              But beyond the fun and festivities, this day carried a deeper
              message — one of lifelong promises, sibling love, and emotional
              growth.
            </p>

            <p>
              <strong>What is Raksha Bandhan All About?</strong>
            </p>
            <p>
              Raksha Bandhan, celebrated across India, is a traditional festival
              where a sister ties a rakhi (sacred thread) on her brother’s
              wrist, symbolizing love, protection, and a lifelong bond. In
              return, the brother promises to support and protect his sister — a
              promise that transcends time and tradition.
            </p>
            <p>
              In recent years, the meaning of Raksha Bandhan has beautifully
              evolved. It’s no longer just about brothers and sisters — it’s
              about the universal bond of care, respect, and togetherness,
              celebrated among siblings, cousins, and even friends.
            </p>

            <p>
              <strong>
                How Red School House Celebrates Sibling Bonds
              </strong>
            </p>
            <p>
              At Red School House Vadodara, we believe in blending culture with
              character building. Here’s how we celebrated this heartfelt
              occasion:
            </p>

            <ul>
              <li>
                <strong>Rakhi-Making Workshop:</strong> Students from all grades
                participated in an exciting DIY rakhi-making session using
                eco-friendly materials like paper, thread, beads, and even
                plantable seed paper. Teachers guided students on the symbolic
                meaning behind each element they used.
              </li>
              <br />
              <li>
                <strong>“Tie a Bond” Activity:</strong> In a beautiful gesture
                of unity, students tied rakhis not just to their siblings, but
                to friends, classmates, and even teachers and trees — embracing
                the spirit of equality, gratitude, and environmental
                responsibility.
              </li>
              <br />
              <li>
                <strong>Storytelling & Values Circle:</strong> Our teachers
                narrated heartwarming tales of sibling love from Indian
                mythology, including the stories of Krishna and Draupadi, and
                Yamuna and Yama — inspiring children to cherish their loved ones
                and build trust-based relationships.
              </li>
              <br />
            </ul>

            <p>
              <strong>
                Why Celebrations Like These Matter in Vadodara
              </strong>
            </p>
            <p>
              Vadodara, known for its rich cultural heritage and festive spirit,
              is home to many artisans and families who make traditional rakhis
              by hand. By celebrating Raksha Bandhan at school, we’re not only
              keeping culture alive, but nurturing future citizens who
              appreciate tradition while embracing inclusivity and
              sustainability.
            </p>

            <p>
              From our family to yours — <br />
              <strong>Happy Raksha Bandhan 2025! 💖</strong>
            </p>

            <p>
              <strong>🗓️ Stay Connected</strong>
            </p>
            <ul>
              <li>
                👉 Visit our Page
              </li>
              <li>
                👉 Learn more about our cultural events
              </li>
            <li>
  👉 Follow us on Instagram{' '}
  <a
    href="https://www.instagram.com/redschoolhousebaroda"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: '#e53935', textDecoration: 'underline' }}
  >
    @redschoolhousebaroda
  </a>
</li>

            </ul>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate('/blog')}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog;
